export default __webpack_public_path__ + "static/media/explore-analogous-inspiration-template.5e1d3d63.pptx";